/// <reference path="smartcenter.module.ts" />

module Meevo.Plugins.SmartCenter {

    import SmartCenterSmartTile = Meevo.Model.SmartCenterSmartTile;

    /**
     * Fill the places where the tiles should be
     * @param {Meevo.Model.SmartCenterSmartTile[]} tiles
     * @returns {number[][]}
     */
    const getFilledTileMatrix = (tiles: SmartCenterSmartTile[]): number[][] => {
        let filledTilesMatrix: number[][] = _.range(3).map(() => _.range(6).map(() => 0));
        tiles.forEach(tile => {
            for (let i = 0; i < tile.columnSpan; i++) {
                let columnPosition = tile.columnPosition + i;
                for (let i = 0; i < tile.rowSpan; i++) {
                    let rowPosition = tile.rowPosition + i;
                    filledTilesMatrix[rowPosition][columnPosition] = 1;
                }
            }
        });
        return filledTilesMatrix;
    };

    interface IEmptyTilesCountOptions {
        rowStart: number;
        rowEnd: number;
        colStart: number;
        colEnd: number;
    }

    /**
     * Returns the number of empty tiles between two tiles
     * @param {number[][]} tileMatrix
     * @param {Meevo.Plugins.SmartCenter.IEmptyTilesCountOptions} options
     * @returns {number}
     */
    const getEmptyTilesCount = (tileMatrix: number[][], options: IEmptyTilesCountOptions): number => {
        let emptyTilesCount: number = 0;
        let goOn: boolean = true;

        while (goOn) {
            emptyTilesCount += tileMatrix[options.rowStart][options.colStart] === 0 ? 1 : 0;

            options.colStart++;
            if (options.colStart >= 6) {
                options.colStart = 0;
                options.rowStart++;
            }

            if (options.rowStart >= options.rowEnd && options.colStart >= options.colEnd) {
                goOn = false;
            }
        }

        return emptyTilesCount;
    };

    class SmartCenterController {

        static $inject = [
            'meevo.plugins.smartCenter.SmartCenterService',
            '$rootScope',
            '$q',
            'meevo.ContextParams',
            'meevo.components.modal.ModalService',
            '$scope',
            '$window',
            '$timeout',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
            'meevo.components.common.DataService',
            'meevo.menuService',
            'meevo.AppSettings',
            '$locale',
            '$translate',
            '$filter'
        ];

        private activeSet: TileSet;

        private tileSets: Array<any>;

        private smartCenterService: SmartCenterService;
        private carousel: any;
        private carouselIndex: number;
        private $rootScope: ng.IRootScopeService;
        private rootStyle: string;
        private pageHeaderStyle: string;
        private tileWidth: number;
        private tileFontSize: string;
        private gridSizerHeight: number;
        private gridSizerWidth: number;
        private currentWindowWidth: number;
        private scope: any;
        private dataService: Meevo.Components.Common.ICommonDataService;
        private static loadCount: number = 0;
        private static hasInitiallyLoaded = false;

        constructor(smartCenterService: SmartCenterService,
            $rootScope: ng.IRootScopeService,
            private $q: ng.IQService,
            contextParams: Meevo.IContextParams,
            private modalService: Meevo.Components.Modal.IModalService,
            $scope: any,
            private $window: ng.IWindowService,
            private $timeout: angular.ITimeoutService,
            private busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            dataService: Meevo.Components.Common.ICommonDataService,
            private menuService: Meevo.MenuService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private $locale: angular.ILocaleService,
            private $translate: angular.translate.ITranslateService,
            private $filter: angular.IFilterService) {
            this.scope = $scope;

            var vm = this;
            vm.scope = this.scope;
            vm.dataService = dataService;
            vm.smartCenterService = smartCenterService;
            vm.carousel = {};
            vm.$rootScope = $rootScope;
            vm.carouselIndex = 0;
            vm.currentWindowWidth = 0;
            vm.rootStyle = "smart-center-root";
            vm.pageHeaderStyle = "smart-center-pageheader";
            vm.autoStartSmartCenter();

            $scope.$watch('smartCenter.carouselIndex', function (value: number) {
                if (vm.tileSets && vm.tileSets[value]) {
                    vm.carouselIndex = value;
                    vm.activeSet = vm.tileSets[value];
                    vm.rootStyle = "smart-center-root " + vm.tileSets[value].themeId;
                    vm.pageHeaderStyle = "smart-center-pageheader " + vm.tileSets[value].themeId;
                    vm.refresh();
                }
            });

            angular.element('.smart-center-container').mousedown(function (e) { if (e.button == 1) return false });

            vm.onInit();

            angular.element($window).bind('orientationchange', function () {
                if ($scope.main.contexts[0].status == "active") {
                    // Wait for orientation animation to change before setting size again
                    $timeout(() => {
                        vm.sizeGridList();
                    }, 200);
                }
            });

            angular.element($window).on('resize', function () {
                if ($scope.main.contexts[0].status == "active") {
                    var newWidth = $window.innerWidth;
                    var updateGridTimer;

                    if (newWidth !== vm.currentWindowWidth) {
                        $timeout.cancel(updateGridTimer);
                    }

                    // Only update if unchanged for 200ms (do not re-size every ms)
                    updateGridTimer = $timeout(function () {
                        vm.sizeGridList();
                    }, 200);
                }
            });

            SmartCenterController.loadCount++;
        }

        onInit = () => {
            var vm = this;
            vm.tileSets = null;
            vm.smartCenterService.getTileSets().then(result => {
                if (!_.isEmpty(result)) {
                    vm.activeSet = _.first(result);
                    vm.tileSets = result;
                    let that = this;
                    vm.tileSets.forEach(function (set, index, tileSets) {
                        set.tiles.forEach(tile => { tile['available'] = true; })

                        if (!set.isHardCoded) {

                            let tempSet = set.tiles.slice(0);
                            let blankTileCount: number = 0;
                            let nextTileOffset = 0;
                            let filledTilesMatrix: number[][] = getFilledTileMatrix(set.tiles);

                            set.tiles.forEach(function (tile, setPosition, set) {
                                if (setPosition !== (set.length - 1)) {
                                    let tileContext = this;
                                    let tileAfter = set[setPosition + 1];
                                    let tileAfterColumnTotal = tileAfter.columnPosition + tileAfter.columnSpan;
                                    let tileAfterRowTotal = tileAfter.rowPosition + tileAfter.rowSpan;
                                    let tileRowTotal = tile.rowPosition + tile.rowSpan;
                                    let tileColumnTotal = tile.columnPosition + tile.columnSpan;


                                    let leftInRow = 6 - tileColumnTotal;
                                    let emptyRowCount = 6 * ((tileAfter.rowPosition + 1) - (tile.rowPosition + 1) - 1);
                                    if (emptyRowCount < 0) {
                                        emptyRowCount = 0;
                                    }
                                    let blankTile = {
                                        rowSpan: 1,
                                        columnSpan: 1,
                                        rowPosition: 0,
                                        columnPosition: 0,
                                        isBlank: true
                                    }

                                    if (setPosition == 0) {

                                        let leadingrows = 6 * tile.rowPosition

                                        if (tile.columnPosition > 0 && tile.rowPosition == 0) {
                                            let addedTiles: number = 0;
                                            blankTileCount = tile.columnPosition;

                                            for (let i = 0; i < blankTileCount; i++) {
                                                tempSet.splice(setPosition + nextTileOffset + i, 0, {
                                                    rowSpan: 1,
                                                    columnSpan: 1,
                                                    rowPosition: tile.rowPosition,
                                                    columnPosition: tile.columnPosition + 1 + i,
                                                    isBlank: true
                                                });

                                                addedTiles++
                                            }
                                            nextTileOffset += addedTiles;
                                        }
                                        else {
                                            blankTileCount = tile.columnPosition + leadingrows;
                                            let addedTiles: number = 0;

                                            for (let i = 0; i < blankTileCount; i++) {

                                                if (i < leadingrows) {
                                                    let columnPosition = ((i) % 6) - 1;
                                                    let rowPosition = Math.floor(((i) / 6) - 1);

                                                    tempSet.splice(setPosition + i, 0, {
                                                        rowSpan: 1,
                                                        columnSpan: 1,
                                                        rowPosition: rowPosition,
                                                        columnPosition: columnPosition,
                                                        isBlank: true
                                                    });
                                                    addedTiles++

                                                }
                                                else {

                                                    tempSet.splice(setPosition + i, 0, {
                                                        rowSpan: 1,
                                                        columnSpan: 1,
                                                        rowPosition: tileAfter.rowPosition,
                                                        columnPosition: i - leadingrows,
                                                        isBlank: true
                                                    });
                                                    addedTiles++

                                                }
                                            }
                                            nextTileOffset += addedTiles;
                                        }

                                    }

                                    if (tile.rowPosition === tileAfter.rowPosition) {
                                        blankTileCount = tileAfter.columnPosition - tileColumnTotal;
                                        let addedTiles: number = 0;

                                        for (let i = 0; i < blankTileCount; i++) {

                                            let isBlocked = vm.checkIsBlocked(set, tile.rowPosition, tileColumnTotal + i);
                                            if (!isBlocked) {
                                                tempSet.splice(setPosition + 1 + nextTileOffset + i, 0, {
                                                    rowSpan: 1,
                                                    columnSpan: 1,
                                                    rowPosition: tile.rowPosition,
                                                    columnPosition: tile.columnPosition + 1 + i,
                                                    isBlank: true
                                                });

                                                addedTiles++
                                            }


                                        }
                                        nextTileOffset += addedTiles;
                                    }
                                    else {
                                        blankTileCount = getEmptyTilesCount(filledTilesMatrix, {
                                            colStart: (<SmartCenterSmartTile>tile).columnPosition,
                                            colEnd: (<SmartCenterSmartTile>tileAfter).columnPosition,
                                            rowStart: (<SmartCenterSmartTile>tile).rowPosition,
                                            rowEnd: (<SmartCenterSmartTile>tileAfter).rowPosition,
                                        });
                                        let addedTiles: number = 0;

                                        for (let i = 0; i < blankTileCount; i++) {

                                            if (i < leftInRow) {
                                                tempSet.splice(setPosition + 1 + nextTileOffset + i, 0, {
                                                    rowSpan: 1,
                                                    columnSpan: 1,
                                                    rowPosition: tile.rowPosition,
                                                    columnPosition: tile.columnPosition + i,
                                                    isBlank: true
                                                });
                                                addedTiles++
                                            }
                                            else if (leftInRow < i && i < (emptyRowCount + leftInRow)) {
                                                let columnPosition = ((i - leftInRow) % 6) - 1;
                                                let rowPosition = Math.floor(((i - leftInRow) / 6) - 1);

                                                let isBlocked = vm.checkIsBlocked(set, rowPosition, columnPosition);
                                                if (!isBlocked) {
                                                    tempSet.splice(setPosition + 1 + nextTileOffset + i, 0, {
                                                        rowSpan: 1,
                                                        columnSpan: 1,
                                                        rowPosition: rowPosition,
                                                        columnPosition: columnPosition,
                                                        isBlank: true
                                                    });
                                                    addedTiles++
                                                }

                                            }
                                            else {
                                                tempSet.splice(setPosition + 1 + nextTileOffset + i, 0, {
                                                    rowSpan: 1,
                                                    columnSpan: 1,
                                                    rowPosition: tileAfter.rowPosition,
                                                    columnPosition: i - (emptyRowCount + leftInRow),
                                                    isBlank: true
                                                });
                                                addedTiles++;
                                            }
                                        }
                                        nextTileOffset += addedTiles;
                                    }
                                }

                            });

                            set.tiles = tempSet;
                        }

                    })
                    _.each(vm.tileSets, (set, that) => {

                        _.each(vm.tileSets, (tile, that) => {

                            let blonk = tile;
                        }, that);

                    }, that);

                }
            }).then((o) => {
                // Longer timeout necessary in case tab switching/initial html not fully loaded
                this.$timeout(() => {
                    this.refresh();
                    vm.sizeGridList();
                }, 1000);
            })

        }
        nextTileSet() {
            if (!_.isEmpty(this.tileSets)) {
                var nextIndex = _.indexOf(this.tileSets, this.activeSet) + 1;
                if ((this.tileSets.length - 1) >= nextIndex) {
                    this.activeSet = this.tileSets[nextIndex];

                }
            }
            //this.refresh();
        }

        previousTileSet() {
            if (!_.isEmpty(this.tileSets)) {
                var previousIndex = _.indexOf(this.tileSets, this.activeSet);
                if (previousIndex >= 0) {
                    this.activeSet = this.tileSets[previousIndex];

                }
            }
            //this.refresh();
        }

        checkIsBlocked(set: Array<any>, rowPosition: number, columnPosition: number): boolean {

            let columnMatch = _.filter(set, function (possibleMatch) {
                if (possibleMatch.columnPosition + (possibleMatch.columnSpan - 1) >= columnPosition && columnPosition >= possibleMatch.columnPosition) {
                    return true
                }
                else if (possibleMatch.columnPosition == columnPosition) {
                    return true
                }
                return false
            })
            let occupiesSpace = _.filter(columnMatch, function (possibleMatch) {
                if (possibleMatch.rowPosition + (possibleMatch.rowSpan - 1) >= rowPosition && rowPosition >= possibleMatch.rowPosition) {
                    return true
                }
                return false
            })

            return occupiesSpace.length != 0
        }


        /**
        * Refreshes the data for the active tile set
        */
        refresh(interactiveRefresh: boolean = false) {
            if (Model.Guard.isNothing(this.activeSet))
                return;
            if (!SmartCenterController.hasInitiallyLoaded) {
                SmartCenterController.hasInitiallyLoaded = true;
                interactiveRefresh = true;
            }
            if (interactiveRefresh) {
                this.busyService.start();
            }
            var activeTiles = this.activeSet.tiles;
            this.smartCenterService.getTileData(this.activeSet).then(data => {
                _.each(data, dataItem => {
                    var tile = _.findWhere(activeTiles, { smartCenterTile_TId: dataItem.smartCenterTile_TId });
                    if (!_.isEmpty(tile)) {
                        this.handleTileData(tile, dataItem);

                        if (tile.smartTileName === 'MembershipConversion' && typeof tile.value === 'object') {
                            tile.value = `
                            ${(<any>tile.value).reduce((all, current) => all + current.Converted, 0)}
                            out of
                            ${(<any>tile.value).reduce((all, current) => all + current.Prospective, 0)}
                            /
                            ${(<any>tile.value).reduce((all, current) => parseFloat((((all + current.Converted / current.Prospective) || 0) * 100).toFixed(2)), 0)}%
                            `;
                        }

                        if (tile.smartTileName === 'PercentageBooked') {
                            tile.value = tile.value.toString().replace(/\s/g, "");
                        }

                        if (tile.smartTileName === 'RebookedAppointments' || tile.smartTileName === 'ServiceProviderRequests') {
                            tile.value[0] = tile.value[0].toString().replace(/\s/g, "");
                        }

                        if (tile.smartTileName === 'RetailUnitsSales') {
                            this.normalizeRetailUnitSalesValues(tile);
                        }

                        if (tile.smartTileName === 'DateCounter') {
                            const dateCounterPayload = JSON.parse(tile.value.toString());
                            tile.value = dateCounterPayload;
                            tile.title = `${this.$translate.instant('LABEL_TODAY_IS')} ${moment(dateCounterPayload.date).format('ddd L')}`;
                        }

                        if (tile.value && typeof tile.value !== 'object') {
                            let input = <any>tile.value;

                            let regexp = /[^\s.]/g;
                            let matchesArr: string[];
                            let inputString = input + '';

                            if (String(inputString).indexOf('{currency}') > -1) {
                                let currencyFilter = this.$filter('meevoCurrency') as angular.IFilterCurrency;
                                let value = input.toString().replace('{currency}', '');
                                let result = currencyFilter(value);

                                matchesArr = result.match(regexp);

                            } else {
                                // Get the length of string excluding spaces and periods for determining if smaller font needed
                                matchesArr = tile.value.toString().match(regexp);
                            }

                            tile.charLength = matchesArr.length;
                        }
                    }
                });
                if (interactiveRefresh) {
                    this.busyService.stop();
                }
            }).then(data => {
                this.sizeGridList();
            });

        }

        prevSlide() {
            this.carouselIndex--;
        }

        nextSlide() {
            this.carouselIndex++;
        }
        //commented out till we get endpoints
        //get smartbackground() {
        //    let color1 = JSON.parse(localStorage.getItem('smartCenterBackground')).stop1;
        //    let color2 = JSON.parse(localStorage.getItem('smartCenterBackground')).stop2;
        //    return `radial-gradient(${color1}, ${color2})`
        //}

        sizeGridList() {
            var root, maxh, maxw, computedh, computedw, INDICATOR_H, TITLE_H, fontSize, CONVOBAR_HEIGHT;
            TITLE_H = 77;
            INDICATOR_H = 47;
            CONVOBAR_HEIGHT = 34;
            root = angular.element('.smart-center-root');
            var cssWidth = root.css('width');
            var cssHeight = root.css('height');
            maxw = cssWidth ? parseInt(cssWidth.slice(0, -2)) - 100 : 0;
            maxh = cssHeight ? parseInt(cssHeight.slice(0, -2)) - INDICATOR_H : 0;

            let gridSizerWidth: number = 0;
            let gridSizerHeight: number = 0;
            let tileFontSize: number = 0;

            //If phone/tablet ul needs to be scrollable
            if (maxw + 100 < 960) {
                gridSizerWidth = maxw + 100;
                gridSizerHeight = maxh + INDICATOR_H;
                tileFontSize = .12 * maxw;

            } else {
                maxh = maxh < 485 ? 485 : maxh;
                computedh = .5 * maxw + TITLE_H;

                //if computed is smaller than max we used computed w and the h that was used to get it(maxh)
                if (computedh < maxh) {
                    gridSizerWidth = maxw;
                    gridSizerHeight = computedh;
                    tileFontSize = .07 * computedh;
                }
                //Else we must be able to use maxw and compute a height to maintain the aspect ratio
                //need to check to ensure this doesnt exceed maxh(maybe i dont know) doesnt sound right
                else {
                    computedw = (maxh - TITLE_H) * 2;

                    gridSizerWidth = computedw;
                    gridSizerHeight = maxh;
                    tileFontSize = .07 * maxh;
                }
            }

            // Update font size if changed
            if (this.tileFontSize !== (tileFontSize.toString() + 'px')) {
                this.tileFontSize = tileFontSize.toString() + 'px';
            }

            // Update size of grid-sizer if changed
            if (this.gridSizerWidth !== gridSizerWidth || this.gridSizerHeight !== gridSizerHeight) {
                angular.element('.grid-sizer').css({ width: gridSizerWidth + 'px', height: gridSizerHeight + 'px' });

                this.gridSizerWidth = gridSizerWidth;
                this.gridSizerHeight = gridSizerHeight;
            }
            this.tileWidth = $(angular.element('.smart-center-tile-value').parents('md-grid-tile')[0]).width();

            if (!this.tileWidth)
                this.tileWidth = $(angular.element('.smart-center-custom-face').parents('md-grid-tile')[0]).width();
        }

        getTileWidth() {
            let width = angular.element('.smart-center-outer-tile').width();
            this.tileWidth = width;
        }

        /**
        * Handle a shortcut coming from a shortcut tile based on the type of the shortcut
        * Currently supports convo and URL shortcut types
        */
        handleShortcut(shortcut: string, shortcutType: TileShortcutType) {
            if (_.isEmpty(shortcut)) {
                return;
            }
            if (shortcutType == TileShortcutType.Convo) {
                if (shortcut === this.appSettings.ROUTE_NAMES.help) {
                    // TODO: If there should be a convo for "help" this handling would move from here to convo.service.ts 
                    // and the convo would be passed along as usual. There is currently no story/requirement for a "help" convo (though maybe there should be)
                    this.menuService.openMeevoHelp();
                } else {
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CONVO_REQUESTED, shortcut);
                }
            } else if (shortcutType == TileShortcutType.Url) {
                let testHttp = new RegExp("^(http|https)://", "i");
                let hasHttp = testHttp.test(shortcut);
                if (hasHttp) {
                    window.open(shortcut, '_blank');
                }
                else {
                    let tempShortcut = "http://" + shortcut;
                    window.open(tempShortcut, '_blank');
                }
            }
        }

        showExtendedData(tile: TileItem) {
            if (!tile.showExtendedDetail) {
                return false;
            }
            if (tile.id == Meevo.Model.SmartTileIds.ServiceProviderRequests) {
                return tile.includedEmployee == Model.IncludedEmployeeEnum.AllEmployees;
            }
            return true;
        }
        handleExtendedInfo(tile: TileItem) {
            /* 
             *  When Tiles are edited in SmartCenter Designer new smartCenterTile_TId are created for each tile If 
             *  SmartCenter is being saved in another browser clicking Any Tile Play Button Will Error Out
             *  TODO: Refactor SmartCenter Designer Saving process
             */
            //Ensures Latest smartCenterTile_TId Is Use In The Event SmartCenter Gets Updated Outside This Context 
            //this.smartCenterService.getTileData(this.activeSet).then((data: TileData[]) => {
            //    let latestTile = _.findWhere(data, { id: tile.id });
            //    if (!latestTile) {
            //        let indexTS = this.tileSets.findIndex(s => s.id === this.activeSet.id);
            //        let indexTile = this.tileSets[indexTS].tiles.findIndex(t => t.id === tile.id);
            //        this.tileSets[indexTS].tiles[indexTile]['available'] = false;
            //        return;
            //    }
            //})

            let tileParam = JSON.parse(tile.parameter);
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/smartCenter/smartCenterTileExtendedInfo.html",
                controller: "meevo.plugins.smartCenter.SmartCenterTileExtendedInfoController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    id: tile.id,
                    tileId: tile.smartCenterTile_TId,
                    title: tile.title,
                    smartTileName: tile.smartTileName,
                    templateKey: tile.extendedDataTemplateKey,
                    smartCenterBusinessTypeId: (<any>this.activeSet).businessTypeId,
                    smartCenterHomeLocationId: (<any>this.activeSet).homeLocationId,
                    smartCenterIsAvailableCo: (<any>this.activeSet).isAvailableCo,
                    parameters: {
                        includedEmployee: tileParam["includedEmployees"],
                        appointmentStateParam: tileParam["appointmentState"],
                        dateRangeParam: tileParam["dateRange"],
                        employee: tileParam['employeeId'] || null,
                        rebookingType: tileParam["rebookingType"]
                    },
                    tile: tile
                }
            };
            this.modalService.showCustom(options);


            // Direct get tile data here
           
            this.$q.all([this.dataService.getSmartTileData(tile.smartCenterTile_TId, this.activeSet.id), this.smartCenterService.getTileData(this.activeSet)]).then(data => {
                let revisedDataItem = data[0]
                let latestTile = _.findWhere(data[1], { smartCenterTile_TId: tile.smartCenterTile_TId });
                revisedDataItem['locationDisplay'] = latestTile.locationDisplay

                this.handleTileData(tile, revisedDataItem);
                if (tile.smartTileName === 'RetailUnitsSales' && typeof tile.value === 'object') {
                    this.normalizeRetailUnitSalesValues(tile);
                }

            }).catch(err => {
                console.log('SmartCenterController: Unexpected Error Occurred')
            })

        }

        handleTileData(tile: TileItem, dataItem: TileData): void {
            tile.value = dataItem.value;
            tile.locationDisplay = dataItem.locationDisplay;
            if (dataItem.lastUpdatedUtc) {
                tile.lastUpdated = moment.utc(dataItem.lastUpdatedUtc).local().toDate();
            }
            tile.cacheExpirationMinutes = dataItem.cacheExpirationMinutes;
            tile.shouldShowRefreshInfo = this.shouldShowRefreshInfo(tile);
        }

        isTileList(value) {
            return angular.isArray(value);
        }

        isCountTile(tile) {
            return !this.isCurrencyTile(tile.id) && !tile.isShortcut && !tile.isImage && !this.isTileList(tile.value) && !this.isCustomTileFace(tile.id);
        }

        isCountRating(value): string {
            let answers = 0,
                allAnswers = 0;

            if (value.length) {
                value.forEach((item) => {
                    if (item.Rating && item.Rating != 0) {
                        answers += item.RatingCount;
                    }
                    allAnswers += item.RatingCount;
                });

            }
            return `( ${answers} out of ${allAnswers} )`;
        }

        isRatingStarsTile(value): number {
            let rating = 0,
                answers = 0;

            if (value.length) {
                value.forEach((item) => {
                    if (item.Rating && item.Rating != 0) {
                        rating += item.Rating * item.RatingCount;
                        answers += item.RatingCount;
                    }
                });
                rating = rating / answers;

                // New rating calculation rounds down to the nearest 0.25 instead of 0.5
                rating = Math.floor(rating * 4) / 4;
                rating = isNaN(rating) ? 0 : rating;
            }
            return rating;
        }

        isCurrencyTile(id) {
            const tileListing: number[] = [
                Meevo.Model.SmartTileIds.EstimatedSales,
                Meevo.Model.SmartTileIds.NetSales,
                Meevo.Model.SmartTileIds.AverageSales,
                Meevo.Model.SmartTileIds.MonthlyRecurringRevenue,
                Meevo.Model.SmartTileIds.ChurnMonthlyRecurringRevenue,
                Meevo.Model.SmartTileIds.ExpansionMonthlyRecurringRevenue,
                Meevo.Model.SmartTileIds.GrowthMonthlyRecurringRevenue
            ];
            return _.contains(tileListing, id);
        }

        private isCustomTileFace(id): boolean {
            const tileIds = [Meevo.Model.SmartTileIds.DateCounter];
            return _.contains(tileIds, id);
        }

        isPreviewTile(id) {
            return Meevo.Components.Controls.SmartCenterDesignerPropertiesHelper.isPreviewTile(id);
        }

        getClientDisplayName(item: any) {
            if (!item) {
                return '';
            }

            let clientDisplayName = item.ClientDisplayName;

            switch (item.ClientTypeEnum) {
                case Model.ClientTypeEnum.AnonymousMale:
                    clientDisplayName = this.$translate.instant('LABEL_ANONYMOUS_MALE');
                    break;
                case Model.ClientTypeEnum.AnonymousFemale:
                    clientDisplayName = this.$translate.instant('LABEL_ANONYMOUS_FEMALE');
                    break;
                case Model.ClientTypeEnum.AnonymousOther:
                    clientDisplayName = this.$translate.instant('LABEL_ANONYMOUS_FEMALE');
                    break;
            }

            return clientDisplayName;
        }

        templateHelper(key: string, templateSuffix: string) {
            let rootPath = 'app/plugins/smartCenter/extendedTileTemplates/';
            return rootPath + key + (Model.Guard.isSomething(templateSuffix) ? templateSuffix : '') + '.html';
        }

        get securityPlaybutton(): boolean {
            return this.securityService.hasSecurity('DATA:SMARTCENTERDESIGNER:FIVESTARRATING:DETAILS' + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
        }

        //66826 - show background functionality
        close(): void {
            if (this.hasMainContexts()) {
                this.scope.main.contexts[0].close();
            }
        }

        hasMainContexts(): boolean {
            return this.scope && this.scope.main && this.scope.main.contexts;
        }

        autoStartSmartCenter(): void {
            if (this.hasMainContexts()) {
                const currentContext = this.scope.main.contexts[0];

                if (currentContext.isHomeContext) {
                    currentContext.close(); //re-hide smart-center and show home.
                } else {
                    if (SmartCenterController.loadCount === 0) {
                        this.dataService.getSettings<Meevo.Model.SmartCenterSettings>(Meevo.Model.BusinessSettingCategoryEnum.SmartCenter, null)
                            .then((response: any) => {
                                let smartSettings: Meevo.Model.SmartCenterSettings = response;

                                if (smartSettings && !smartSettings.autoLoadSmartCenter) {
                                    this.scope.main.contexts[0].close();
                                }
                            });
                    }
                }
            }
        }

        reopenSmartCenter(): void {
            if (this.hasMainContexts()) {
                const currentContext = this.scope.main.contexts[0];

                if (currentContext.isHomeContext) {
                    const backgroundElem: HTMLElement = document.getElementById('default-background');
                    const smartCenterElem: HTMLElement = document.getElementById('smart-center-content');

                    if (smartCenterElem && backgroundElem) {
                        smartCenterElem.setAttribute('style', 'display: ');
                        backgroundElem.setAttribute('style', 'display: none');

                        currentContext.isHomeContext = false;
                        currentContext.title = 'HERO_SUB_SMARTCENTER';
                        currentContext.reloadOnSearch = true;

                        //re-add X button on smart-center.
                        const xButton = document.getElementsByClassName('meevo-context-close')[0];
                        xButton.setAttribute('style', 'display: ');
                    }
                }
            }
        }

        public shouldShowRefreshInfo(tile: TileItem): boolean {
            const tilesToHideRefreshInfo = [SmartTileNames.dateCounter];
            if (!tile.lastUpdated) {
                return false;
            }
            if (tilesToHideRefreshInfo.indexOf(tile.smartTileName) >= 0) {
                return false;
            }
            return true;
        }

      private normalizeRetailUnitSalesValues(tile: TileItem): void {  
            tile.value[1] = `${this.$filter('currency')(tile.value[1], this.$locale.NUMBER_FORMATS.CURRENCY_SYM, 2)}`;
          tile.charLength = tile.value[0].length + tile.value[1].length + 3;
          tile.value[0] = (tile.value[0] ? `${tile.value[0]} /` : tile.value[0]);
        }
    }

    angular.module("meevo.plugins.smartCenter")
        .controller("meevo.plugins.smartCenter.smartCenterController", SmartCenterController);
}